document.addEventListener('DOMContentLoaded', () => {

	/**
	 * Format Time String
	 *
	 * @param {number} timeMilliseconds - The time in milliseconds
	 * @returns {string} - The formatted time string in the format of hours and minutes
	 */
	function formatTimeString(timeMilliseconds) {
		const minutes = Math.floor((timeMilliseconds / (1000 * 60)) % 60).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
    const hours = Math.floor((timeMilliseconds / (1000 * 60 * 60)));

    // Build the display string
		let displayString = '';
		if (hours > 0) {
			const formattedHours = hours.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			displayString += `${formattedHours}h `;
		}

		if (minutes > 0) {
			displayString += `${minutes}m`;
		} else {
			displayString += '00m';
		}

    return displayString;
	}

	/**
	 * Get time elapsed
	 *
	 * Calculates the difference between the current time and the target date time and return in milliseconds
	 *
	 * @param {string} targetDateTime - The target date and time to compare in date() format or milliseconds
	 * @returns {number} - The difference in milliseconds
	 */
	function getTimeElapsed(targetDateTime) {
		return new Date().getTime() - targetDateTime;
	}

	/**
	 * Update Coupling Time Cell
	 * Cycles through each coupling hours cell and updates the cell with the amount of time that has passed since the start time
	 *
	 * @param {NodeList} couplingHours - The list of coupling hours cells
	 * @returns {void}
	 */
	function updateCouplingTimeCell(couplingHours) {
		// Get all the coupling hours
		couplingHours.forEach((element) => {
			const targetCell = element;
			const targetDateString = targetCell.getAttribute('data-time-start');
			const couplingTotal = targetCell.getAttribute('data-no-couplings');

			const targetDate = new Date(targetDateString);
			const timeElapsed = getTimeElapsed(targetDate);
			const couplingTimeElapsed = timeElapsed * couplingTotal;
			const displayString = formatTimeString(couplingTimeElapsed);

			// Update current cell with the display string
			targetCell.innerHTML = displayString;
		});
	}

	/**
	 * Update Total Coupling Hours
	 * Updates the total coupling hours cell with the sum of all the coupling hours
	 *
	 * @param {NodeList} couplingHours - The list of coupling hours cells
	 * @returns {void}
	 */
	function updateTotalCouplingHours(couplingHours) {

		// Initialize the total time to 0
		let totalTime = 0;
		const couplingTotalEle = document.querySelector('.coupling-hours-total');

		// Loop through each coupling hours cell and add them all together
		couplingHours.forEach((element) => {
			// Grab the date-time-start attribute which houses the start time of the coupling
			const targetDateString = element.getAttribute('data-time-start');
			const targetCouplingTotal = element.getAttribute('data-no-couplings');

			const targetDate = new Date(targetDateString);
			const pastTIme = getTimeElapsed(targetDate) * targetCouplingTotal;

			// Total amount of time between now and the start time in milliseconds
			totalTime += pastTIme;
		});

		// Update the total coupling hours cell with the total time
		couplingTotalEle.innerHTML = formatTimeString(totalTime);
	}

	/**
	 * Update Time
	 * Updates the time counter for each coupling
	 * @returns {void}
	 */
	function updateTime() {
		const couplingHours = document.querySelectorAll('.couplings-hours');
		updateCouplingTimeCell(couplingHours);
		updateTotalCouplingHours(couplingHours);
	}

	// Initial call to display the time immediately
	updateTime();

	// Update the time counter every second
	setInterval(updateTime, 1000);
});
